(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[422],{

/***/ 5236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[business]/access/[category]/[article]",
      function () {
        return __webpack_require__(5619);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2132);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2991);




const CSP = __webpack_require__(5331);
function MetaBlock(props) {
    const { title , description , leadImage  } = props;
    const [isAfterpay, setIsAfterpay] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setIsAfterpay(window.location.host.startsWith("afterpay.com"));
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "Content-Security-Policy",
                content: CSP
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "ZJMu9MsvjHJwPn0kcq31cioCrPxAw0HHWqWOqXpq1-Y"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            !isAfterpay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            leadImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: leadImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:image",
                        content: leadImage
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 5331:
/***/ (function(module) {

"use strict";
// Used for Staging and Production

const CSP_SETTINGS = {
    "script-src": [
        "'self'",
        "'unsafe-eval'",
        "'unsafe-inline'",
        "*.afterpay.com",
        "*.clearpay.co.uk",
        "*.clearpay.com",
        "*.googleapis.com",
        "public.fbot.me",
        "static.fbot.me",
        "campaign.fbot.me",
        "lcx-embed.bambuser.com",
        "www.googletagmanager.com",
        "*.onetrust.com",
        "cdn.branch.io",
        "sc-static.net",
        "snap.licdn.com",
        "connect.facebook.net",
        "munchkin.marketo.net",
        "www.googleadservices.com",
        "cdn.dashhudson.com",
        "djnf6e5yyirys.cloudfront.net",
        "cdn.builder.io",
        "t.contentsquare.net",
        "www.google-analytics.com",
        "googleads.g.doubleclick.net",
        "app.link",
        "v5tufwer.micpn.com",
        "pi.pardot.com",
        "tag.clearbitscripts.com/v1/pk_ba428737ee82fd942f13030da0c2629b/tags.js",
        "tag.rmp.rakuten.com",
        "metadata-static-files.sfo2.cdn.digitaloceanspaces.com/pixel/lp.js",
        "x.clearbitjs.com/v2/pk_ba428737ee82fd942f13030da0c2629b/tracking.min.js",
        "x.clearbitjs.com/v2/pk_ba428737ee82fd942f13030da0c2629b/destinations.min.js",
        "analytics.tiktok.com/i18n/pixel/events.js",
        "analytics.tiktok.com/i18n/pixel/config.js",
        "analytics.tiktok.com/i18n/pixel/identify.js",
        "bat.bing.com",
        "afterpay-business-site.vercel.app",
        "business.dijitally.com",
        "*.ads-twitter.com",
        "js.adsrvr.org",
        "cdn.bizible.com",
        "analytics.twitter.com",
        "t.co",
        "bat.bing.com",
        "widget.trustpilot.com"
    ],
    "img-src": [
        "'self'",
        "data:",
        "*.afterpay.com",
        "*.clearpay.co.uk",
        "maps.gstatic.com",
        "*.googleapis.com",
        "*.ggpht",
        "cdn.builder.io",
        "static.fbot.me",
        "www.google.co.nz",
        "www.google.co.uk",
        "www.google.com",
        "www.google.com.au",
        "www.googletagmanager.com",
        "px.ads.linkedin.com",
        "www.facebook.com",
        "p.adsymptotic.com",
        "cdn.branch.io",
        "www.google-analytics.com",
        "public.fbot.me",
        "connect.facebook.net",
        "*.onetrust.com",
        "cdn.dashhudson.com",
        "likeshop.me",
        "track.linksynergy.com",
        "consent.linksynergy.com",
        "www.kmart.com.au",
        "www.bigw.com.au/",
        "www.pacsun.com",
        "afterpay-business-site.vercel.app",
        "business.dijitally.com",
        "cdn.bizible.com",
        "*.google.ie",
        "bat.bing.com",
        "t.co",
        "cdn.bizibly.com",
        "cdn.builder.com"
    ],
    "object-src": [
        "'none'"
    ],
    "base-uri": [
        "'none'"
    ]
};
const CSP = Object.entries(CSP_SETTINGS).reduce((previousValue, param)=>{
    let [key, cspValues] = param;
    const cspString = cspValues.join(" ");
    return "".concat(previousValue, " ").concat(key, " ").concat(cspString, ";");
}, "").trim();
module.exports = CSP;


/***/ }),

/***/ 5619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5102);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7656);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2132);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5407);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2991);
/* harmony import */ var _builder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5163);
/* harmony import */ var _components_back_to_latest_article_back_to_latest_article__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4490);
/* harmony import */ var _components_business_article_bio_block_business_article_bio_block__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6094);
/* harmony import */ var _components_business_article_categories_block_business_article_categories_block__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3770);
/* harmony import */ var _components_business_article_contributor_block_business_article_contributor_block__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9948);
/* harmony import */ var _components_business_article_single_hero_business_article_single_hero__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2379);
/* harmony import */ var _components_business_share_icons_business_share_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8916);
/* harmony import */ var _components_layouts_default_layout__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4670);
/* harmony import */ var _components_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2135);
/* harmony import */ var _components_newsletter_signup_section_newsletter_signup_section__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7048);
/* harmony import */ var _components_related_articles_related_articles__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(3510);
/* harmony import */ var _helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1198);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7868);



















(0,_builder__WEBPACK_IMPORTED_MODULE_6__/* .registerComponents */ .Q)();
var __N_SSG = true;
function Page(ctx) {
    var ref, ref1;
    const { article , footerItems , categories  } = ctx;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_18__/* .useLocale */ .bU)();
    const [stateArticle, setStateArticle] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(article);
    const [relatedArticles, setRelatedArticles] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        let cancelled = false;
        const updateRelatedArticles = (newArticle)=>{
            (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_17__/* .getRelatedArticles */ .eA)(newArticle, locale).then((relatedArticlesRaw)=>{
                if (!cancelled) {
                    setRelatedArticles(relatedArticlesRaw);
                }
            });
        };
        if ((_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isPreviewing */ .Ib.isPreviewing || _builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isEditing */ .Ib.isEditing) && router.query["builder.overrides.article"]) {
            (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_17__/* .getArticleFromID */ .NE)(router.query["builder.overrides.article"]).then((articleFromBuilder)=>{
                if (articleFromBuilder && !cancelled) {
                    const mappedArticle = (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_17__/* .mapBuilderObjectToArticle */ .Jq)(articleFromBuilder);
                    setStateArticle(mappedArticle);
                    updateRelatedArticles(mappedArticle);
                }
            });
        } else {
            if (article) {
                setStateArticle(article);
                updateRelatedArticles(article);
            }
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        stateArticle,
        router.query
    ]);
    if (router.isFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
            children: "Loading..."
        });
    }
    const isLive = !_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isEditing */ .Ib.isEditing && !_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isPreviewing */ .Ib.isPreviewing;
    if (!stateArticle && isLive) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "robots",
                            content: "noindex"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "title"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: 404
                })
            ]
        });
    }
    if (!stateArticle) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
            children: "Loading..."
        });
    }
    const leadCategory = (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_17__/* .mapBuilderObjectToCategory */ .yP)(article === null || article === void 0 ? void 0 : article.categories[0]);
    const relatedArticlesData = {
        title: leadCategory === null || leadCategory === void 0 ? void 0 : leadCategory.name,
        description: leadCategory === null || leadCategory === void 0 ? void 0 : leadCategory.description,
        viewAllSeriesText: "View All Articles",
        viewAllSeriesUrl: (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_18__/* .localifyLink */ .Bj)("/".concat(locale).concat(leadCategory.categoryUrl), locale),
        articles: relatedArticles
    };
    var ref2, ref3, ref4;
    const breadcrumbItems = [
        {
            link: "/business/access",
            name: "Access"
        },
        {
            link: (ref2 = leadCategory === null || leadCategory === void 0 ? void 0 : leadCategory.categoryUrl) !== null && ref2 !== void 0 ? ref2 : "",
            name: (ref3 = leadCategory === null || leadCategory === void 0 ? void 0 : leadCategory.name) !== null && ref3 !== void 0 ? ref3 : ""
        },
        {
            link: "",
            name: (ref4 = article === null || article === void 0 ? void 0 : article.title) !== null && ref4 !== void 0 ? ref4 : ""
        }
    ];
    let targetUrl = "/".concat(locale).concat(article.articleUrl);
    if (true) {
        targetUrl = "".concat((window === null || window === void 0 ? void 0 : window.origin) || "", "/").concat(locale).concat(article.articleUrl);
    }
    var _seoTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                title: (_seoTitle = article.seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : article.title,
                description: article.seoDescription,
                leadImage: article.leadImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_default_layout__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                footerItems: footerItems,
                categories: categories,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_business_article_single_hero_business_article_single_hero__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        article: article,
                        breadcrumbs: breadcrumbItems
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .BuilderComponent */ .VD, {
                        model: "article",
                        content: stateArticle.builderModel
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_business_article_categories_block_business_article_categories_block__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        categories: stateArticle.categories
                    }),
                    article.author && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_business_article_bio_block_business_article_bio_block__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        articleAuthor: stateArticle.author
                    }),
                    !!((ref = article.contributors) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_business_article_contributor_block_business_article_contributor_block__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        contributors: article.contributors,
                        hasAuthorBefore: !!((ref1 = article.author) === null || ref1 === void 0 ? void 0 : ref1.name)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_business_share_icons_business_share_icons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        shareUrl: targetUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_back_to_latest_article_back_to_latest_article__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        latestArticleUrl: (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_18__/* .localifyLink */ .Bj)("/".concat(locale, "/business/access"), locale)
                    }),
                    !!relatedArticles.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_related_articles_related_articles__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                        relatedArticles: relatedArticlesData
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_newsletter_signup_section_newsletter_signup_section__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [67,585,613,722,674,774,888,179], function() { return __webpack_exec__(5236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);